import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    services: [],
    message: ''
  });
  
  const [status, setStatus] = useState('');

  const serviceOptions = [
    { id: 'keynote', label: "It's Not About the Fall, It's About the Bounce (Keynote)" },
    { id: 'fit-workshop', label: 'F-IT Workshop' },
    { id: 'train-trainer', label: 'Train The Trainer' },
    { id: 'fit-app', label: 'F-IT App' },
    { id: 'fyou-workshops', label: 'F-YOU Workshops' },
    { id: 'essential-skills', label: 'F-YOU Essential Skills' }
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleServiceChange = (serviceId) => {
    setFormData(prev => ({
      ...prev,
      services: prev.services.includes(serviceId)
        ? prev.services.filter(s => s !== serviceId)
        : [...prev.services, serviceId]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    try {
      // Get selected service labels
      const selectedServices = formData.services.map(id => 
        serviceOptions.find(s => s.id === id)?.label
      ).join(', ');
      
      // Create mailto link as fallback
      const subject = `F-IT Score Enquiry: ${selectedServices || 'General Enquiry'}`;
      const body = `
Name: ${formData.name}
Email: ${formData.email}
Company: ${formData.company || 'Not provided'}

Services Interested In:
${selectedServices || 'Not specified'}

Message:
${formData.message}
      `;
      
      const mailtoLink = `mailto:hello@f-itscore.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.location.href = mailtoLink;
      
      setStatus('success');
      setFormData({
        name: '',
        email: '',
        company: '',
        services: [],
        message: ''
      });
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="contact-page">
      <section className="contact-hero" style={{
        background: 'linear-gradient(135deg, #FF6B35 0%, #e55a2b 100%)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Option 3: Pattern of small logos */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          opacity: 0.08,
          backgroundImage: 'url(/fit-logo.jpg)',
          backgroundSize: '150px 150px',
          backgroundRepeat: 'repeat',
          zIndex: 0
        }}></div>
        <div className="container" style={{position: 'relative', zIndex: 1}}>
          <div style={{backgroundColor: '#000', display: 'inline-block', padding: '20px 40px', borderRadius: '8px'}}>
            <h1 style={{color: 'white', margin: 0}}>Contact</h1>
          </div>
          <p className="hero-tagline-mobile">Born from lived experience, built on psychology, driven by passion</p>
          <p className="lead">We're here to answer your questions and help you get&nbsp;started</p>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>We're Here to Help</h2>
              <p>Whether you're interested in learning more about F-IT Score, booking a workshop, or discussing how we can support your organisation's wellbeing, health & safety journey - we're always here to listen and&nbsp;help.</p>
              
              <p style={{marginTop: '20px'}}>Complete the form and we'll get back to you within 24 hours on business days. Every conversation starts with understanding your unique challenges and&nbsp;goals.</p>

              <div style={{marginTop: '30px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px'}}>
                <h3 style={{marginTop: 0}}>Our Address</h3>
                <p style={{marginBottom: '5px'}}>F-IT Score</p>
                <p style={{marginBottom: '5px'}}>Halfway Farm Cottage</p>
                <p style={{marginBottom: '5px'}}>Newark Road, Swinderby</p>
                <p style={{marginBottom: '5px'}}>Lincoln, LN6 9HN</p>
                <p style={{marginBottom: 0}}>United Kingdom</p>
              </div>

              <div style={{marginTop: '20px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px'}}>
                <h3 style={{marginTop: 0}}>Email</h3>
                <p style={{marginBottom: 0}}><a href="mailto:hello@f-itscore.com" style={{color: '#FF6B35', fontWeight: 'bold'}}>hello@f-itscore.com</a></p>
              </div>

              <div style={{marginTop: '20px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px'}}>
                <h3 style={{marginTop: 0}}>Phone</h3>
                <p style={{marginBottom: '5px'}}><strong>01636 550190</strong> (Option 1 - P2bS)</p>
                <p style={{marginBottom: 0, fontSize: '0.9em', color: '#666'}}>Office Hours: Monday - Thursday, 9am - 5pm</p>
              </div>

              <div className="connect-section" style={{backgroundColor: '#FF6B35', marginTop: '30px', padding: '25px', borderRadius: '8px', color: 'white'}}>
                <h3 style={{color: 'white', marginTop: 0}}>Connect With Us</h3>
                <p style={{marginBottom: '15px'}}>F-IT Score is part of the P2bS and Anker & Marsh family.</p>
                <div style={{marginBottom: '10px'}}>
                  <a href="http://www.ankerandmarsh.com" target="_blank" rel="noopener noreferrer" style={{color: 'white', textDecoration: 'underline', display: 'block', marginBottom: '8px'}}>Visit Anker & Marsh</a>
                  <a href="https://www.p2bs.org" target="_blank" rel="noopener noreferrer" style={{color: 'white', textDecoration: 'underline', display: 'block'}}>Visit P2bS</a>
                </div>
              </div>
            </div>

            <div className="contact-form-container">
              <form onSubmit={handleSubmit} className="contact-form">
                <h2>Send Us a Message</h2>
                
                <div className="form-group">
                  <label htmlFor="name">Your Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Your Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="company">Company / Organisation</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Your company name"
                  />
                </div>

                <div className="form-group">
                  <label>Services You're Interested In <span style={{fontSize: '12px', color: '#666'}}>(select all that apply)</span></label>
                  <div style={{display: 'grid', gap: '10px', marginTop: '10px'}}>
                    {serviceOptions.map(service => (
                      <label key={service.id} style={{display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '10px', backgroundColor: formData.services.includes(service.id) ? '#FFF5F0' : '#f9f9f9', borderRadius: '6px', border: formData.services.includes(service.id) ? '2px solid #FF6B35' : '2px solid transparent', transition: 'all 0.2s'}}>
                        <input
                          type="checkbox"
                          checked={formData.services.includes(service.id)}
                          onChange={() => handleServiceChange(service.id)}
                          style={{marginRight: '12px', width: '18px', height: '18px', accentColor: '#FF6B35'}}
                        />
                        <span style={{fontSize: '14px'}}>{service.label}</span>
                      </label>
                    ))}
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="6"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us more..."
                    required
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-orange" disabled={status === 'sending'}>
                  {status === 'sending' ? 'Sending...' : 'Send Message'}
                </button>

                {status === 'success' && (
                  <div className="form-message success">
                    Thank you! Your message has been sent. We'll get back to you soon.
                  </div>
                )}
                {status === 'error' && (
                  <div className="form-message error">
                    Sorry, there was an error. Please email us directly at hello@f-itscore.com
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
